// listar senaste eventsen i systemet, detaljer kommer i idictionary<string,string> form så nån form av key,value lista ploppas ut för varje rad
import ClpTable from "components/ClpTable"
import { t } from "i18next"
import { useTranslation } from "react-i18next"
import Moment from "react-moment"
import { StyledTableContainer } from "shared/styled/Global"

const DataCell = ({ properties }) => {
  return Object.entries(properties).map((item, key) => {
    return (
      <div key={key}>
        {item[0]}:{item[1]}
      </div>
    )
  })
}

const columns = [
  {
    accessorKey: "id",
    header: "Id"
  },
  {
    accessorKey: "eventTime",
    header: "Tidpunkt",
    cell: ({ cell }) => {
      return <Moment format="lll:ss">{cell.row.original.eventTime}</Moment>
    }
  },
  {
    accessorKey: "name",
    header: "Typ"
  },
  {
    accessorKey: "description",
    header: t("global.description", "Description")
  },
  {
    accessorKey: "properties",
    header: "Data",
    cell: ({ cell }) => {
      return <DataCell properties={cell.row.original.properties} />
    }
  }
]

export const EventsList = ({ eventResult }) => {
  return (
    <StyledTableContainer marginTop={2}>
      <ClpTable rows={eventResult.data} columns={columns} loadingState={eventResult.status} />
    </StyledTableContainer>
  )
}
